<template>
  <div>
    <div v-if="dataWrapFiveMeter && dataWrapFiveMeter.length">
      <div v-if="isExporting" id="overlay">
        <b-spinner variant="info" label="Loading..." />
      </div>
      <div class="row" style="border: 1px solid #e0e0e0">
        <div class="d-flex col-12 justify-content-between px-3 py-2" style="background-color: #f8f8fb;">
          <div>
            <h5 class="text-list-rokomo-7 mb-1">履歴照会</h5>
          </div>
        </div>
        <div class="p-0">
          <Spliter :initialLeftWidth="isIpad ? 170 : 250" :maxWidth="isIpad ? 200 : 500">
            <template #left>
              <div class="col-12 ps-1">
                <div class="mt-2 px-1">
                  <b-button @click="exportToPDF" :disabled="checkedIds.length == 0" class="w-lg btn-edit"
                    :class="{ 'btn-disabled': checkedIds.length == 0 }">PDF出力</b-button>
                </div>
                <div class="table-responsive mt-2 mb-0 scroll">
                  <vue-loadmore :on-refresh="onRefresh" :finished="finished" finished-text=" ">
                    <table class="table align-middle mb-0" id="table">
                      <tbody>
                        <tr v-for="(item, index) in dataWrapFiveMeter" :key="index" style="cursor: pointer"
                          @click="selectFiveMeter(item, index)">
                          <td class="text-center" :class="{ 'bg-active-five-meter': index === clickIndex }">
                            <input class="form-check-input" type="checkbox" @click.stop="checkedFiveMeter(item.id)"
                              id="formCheckRight2" :checked="isChecked(item.id)" style="font-size: 24px; margin: 0;" />
                          </td>
                          <td width="80%" :class="{ 'bg-active-five-meter': index === clickIndex }">
                            <h5 class="text-list-five-meter mb-0">
                              {{ item.created_at | fomatDate2 }}
                            </h5>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </vue-loadmore>
                </div>
              </div>
            </template>

            <template #right>
              <div class="col-12 px-3 pt-3 position-relative" style="font-size: 16px; ">
                <div v-if="fiveMeterAi">
                  <div class="pt-3">
                    <HokouAiResult :is-show="Boolean(fiveMeterAi)" :loading="false" :user="user" :result="fiveMeterAi"
                      :firstResult="firstFiveMeterAi" :latestResult="latestFiveMeterAi" :styleFiveMeter="true" />
                  </div>
                </div>
              </div>
            </template>
          </Spliter>
        </div>
      </div>
    </div>
    <div v-else class="undefine">
      <img src="@/assets/images/no-data.jpg" alt="" />
      <div class="mt-3">詳細データはありません。</div>
    </div>
    <vue-html2pdf :show-layout="false" :enable-download="true" :preview-modal="false"
      :paginate-elements-by-height="10000" :filename="filename" :pdf-quality="1" ref="html2Pdf" pdf-format="a4">
      <div slot="pdf-content" ref="printContent" style="padding: 30px;">
        <div v-for="(id, index) in checkedIds" :key="id" :class="['pdf-content']" :style="{
          marginTop: index > 0 ? `${-205 + index * 0.7}px` : '0px',
          marginBottom: index === checkedIds.length - 1 ? '-300px' : '0px',
        }">
          <HokouAiResult :is-show="true" :loading="false" :user="user" :result="getResultById(id)"
            :firstResult="getFirstResultById(id)" :latestResult="getLatestResultById(id)" :styleExport="true"
            class="scaled-hokou-ai-result" />
        </div>
      </div>
    </vue-html2pdf>
  </div>
</template>
<script>
import { filter } from "../../helpers/Vue-Filter";
import api from "@/api";
import HokouAiResult from '@/components/widgets/hokou-ai.vue';
import VueHtml2pdf from 'vue-html2pdf';
import Spliter from './spliter.vue';
import Loader from "./loader";

export default {
  components: {
    HokouAiResult,
    VueHtml2pdf,
    Spliter,
    Loader,
  },
  filters: {
    ...filter,
  },
  props: ["fiveMeter", "pagination", "time_out_facility", "filename"],
  data() {
    return {
      clickIndex: null,
      finished: false,
      currentPage: 1,
      selectedFiveMeter: null,
      fiveMeterAi: null,
      firstFiveMeterAi: null,
      latestFiveMeterAi: null,
      user: null,
      dataWrapFiveMeter: this.fiveMeter,
      checkedIds: [],
      checkedIdsPdf: [],
      isExporting: false,
      isIpad: false,
    };
  },
  async mounted() {
    await this.loadAllFiveMeterData();
    if (this.dataWrapFiveMeter && this.dataWrapFiveMeter.length > 0) {
      this.selectFiveMeter(this.dataWrapFiveMeter[0], 0);
    }
  },
  created() {
    if (window.innerWidth <= 1024 && window.innerWidth >= 768) {
      this.isIpad = true;
    }
  },
  computed: {

  },
  methods: {
    clearCheck() {
      this.checkedIds = [];
    },
    onRefresh() {
      this.finished = false;
      this.currentPage = 1;
    },
    async loadAllFiveMeterData() {
      try {
        let page = 2;
        while (page <= this.pagination.last_page) {
          const response = await api.listFiveMeter(this.$route.params.id, this.time_out_facility, page);
          if (response) {
            this.dataWrapFiveMeter = this.dataWrapFiveMeter.concat(response.data.data);
          }
          page++;
        }
        this.finished = true;
      } catch {
        this.finished = true;
      }
    },
    checkedFiveMeter(id) {
      const index = this.checkedIds.indexOf(id);
      if (index === -1) {
        this.checkedIds.push(id);
      } else {
        this.checkedIds.splice(index, 1);
      }
    },
    isChecked(id) {
      return this.checkedIds.includes(id);
    },
    async selectFiveMeter(item, index) {
      this.clickIndex = index;
      this.selectedFiveMeter = item;
      this.fiveMeterAi = item.five_meter_ai;
      this.firstFiveMeterAi = this.getFirstResultById(item.id);
      this.latestFiveMeterAi = this.getLatestResultById(item.id);
    },
    async exportToPDF() {
      try {
        this.isExporting = true;
        this.checkedIds = this.checkedIds.sort((a, b) => b - a);
        await this.$refs.html2Pdf.generatePdf();
        this.checkedIds = [];
      } catch (error) {
        console.log(error);
      } finally {
        setTimeout(() => this.isExporting = false, 500);
      }
    },
    getResultById(id) {
      const item = this.dataWrapFiveMeter.find(item => item.id === id);
      return item ? item.five_meter_ai : null;
    },
    getFirstResultById(id) {
      const item = this.dataWrapFiveMeter[this.dataWrapFiveMeter.length - 1];
      if (item && item.id === id) {
        return null;
      }
      return item ? item.five_meter_ai : null;
    },
    getLatestResultById(id) {
      const index = this.dataWrapFiveMeter.findIndex(item => item.id === id);
      const itemCheck = this.dataWrapFiveMeter[this.dataWrapFiveMeter.length - 1];
      if (index !== -1 && index < this.dataWrapFiveMeter.length - 1) {
        const nextItem = this.dataWrapFiveMeter[index + 1];
        if (itemCheck.id === nextItem.id) {
          return null;
        }
        return nextItem.five_meter_ai;
      }
      return null;
    },
  },
};
</script>


<style scoped>
.scroll {
  max-height: 80vh;
  overflow-y: scroll;
}

.undefine {
  height: 250px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  color: #404040;
}

.text-list-rokomo-7 {
  color: #404040;
  font-size: 16px;
  font-weight: 700;
}

::-webkit-scrollbar {
  width: 5px;
}

::-webkit-scrollbar-thumb {
  background: #888;
  border-radius: 4px;
}

::-webkit-scrollbar-thumb:hover {
  background: #555;
}

.table-responsive {
  overflow-x: auto;
}

.text-list-five-meter {
  color: #404040;
  font-size: 16px;
  font-weight: 700;
}

.bg-active-five-meter {
  background: #65ace2;
}

.btn-edit {
  color: white;
  border: none;
  border-radius: 4px;
  padding: 5px;
  font-size: 14px;
  margin-left: 24px;
}

.btn-edit:hover {
  background-color: #0056b3;
}

.btn-disabled {
  background-color: #e0e0e0 !important;
  color: #ffffff !important;
  cursor: not-allowed;
}

.scaled-hokou-ai-result {
  transform: scale(0.8) translateX(-45px);
  transform-origin: top left;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 100%;
  margin-left: 115px;
}

#overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(255, 255, 255, 0.5);
  /* Semi-transparent background */
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 9999;
  /* Ensure it appears above all other elements */
}
</style>
